import React, { useEffect, useState } from 'react';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authService } from '../services/api';

const AcceptInvitePage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [inviteRole, setInviteRole] = useState<string>('');
  const [username, setUsername] = useState('');
  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      setError('Invite token missing');
      return;
    }

    authService
      .getInvite(token)
      .then((response) => setInviteRole(response.data.role))
      .catch((requestError) => setError(requestError.response?.data?.error || 'Invite not found'))
      .finally(() => setLoading(false));
  }, [token]);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!token) return;
    setSubmitting(true);
    setError(null);

    try {
      await authService.acceptInvite(token, username, password, fullName);
      navigate('/login');
    } catch (requestError: any) {
      setError(requestError.response?.data?.error || 'Failed to accept invite');
    } finally {
      setSubmitting(false);
    }
  };

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="page-shell auth-shell">
      <div className="auth-panel card">
        <p className="eyebrow">Invite</p>
        <h1 className="page-heading auth-heading">Join via onboarding link</h1>
        {loading ? (
          <p className="page-copy">Loading invite...</p>
        ) : error ? (
          <div className="alert alert-error">{error}</div>
        ) : (
          <>
            <p className="page-copy auth-copy">This invite grants the role <span className={`role-pill role-${inviteRole}`}>{inviteRole}</span>.</p>
            <form onSubmit={handleSubmit} className="compose-form">
              <div className="form-group">
                <label className="form-label" htmlFor="full_name">Full name</label>
                <input id="full_name" className="form-input" value={fullName} onChange={(event) => setFullName(event.target.value)} required />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="username">Username</label>
                <input id="username" className="form-input" value={username} onChange={(event) => setUsername(event.target.value)} required />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="password">Password</label>
                <input id="password" type="password" className="form-input" value={password} onChange={(event) => setPassword(event.target.value)} required />
              </div>
              <div className="action-row">
                <button type="submit" className="btn btn-primary" disabled={submitting}>{submitting ? 'Creating account...' : 'Accept invite'}</button>
              </div>
            </form>
          </>
        )}
        <p className="auth-footer">Prefer public signup? <Link to="/register">Register as a member</Link></p>
      </div>
    </div>
  );
};

export default AcceptInvitePage;
